import { render, staticRenderFns } from "./NameCard.vue?vue&type=template&id=00bedd7d&scoped=true&"
import script from "./NameCard.vue?vue&type=script&lang=js&"
export * from "./NameCard.vue?vue&type=script&lang=js&"
import style0 from "./NameCard.vue?vue&type=style&index=0&id=00bedd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bedd7d",
  null
  
)

export default component.exports